export default "static/media/decor2.43a640d.svg"